import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Head = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="head icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.24 0C33.7835 0 41.52 7.73652 41.52 17.28V19.9922C44.5536 20.5102 47.28 23.3977 47.28 26.6294C47.28 30.0811 44.6776 32.9249 41.3278 33.3058C40.0799 41.6227 32.9047 48 24.24 48C15.5753 48 8.40013 41.6227 7.15217 33.3058C3.80242 32.9249 1.20001 30.0811 1.20001 26.6294C1.20001 23.3977 3.92645 20.5103 6.95999 19.9922V17.28C6.95999 7.73652 14.6965 0 24.24 0ZM8.88 26.6825V24.1984V24.0057C18.5001 24.8459 25.1558 21.2179 28.6527 13.2123C30.8094 18.3051 34.4743 21.6041 39.6 23.0469V30.72C39.6 39.2031 32.7231 46.08 24.24 46.08C15.7569 46.08 8.88 39.2031 8.88 30.72V26.6825ZM39.6 21.0434V17.28C39.6 8.79691 32.7231 1.92 24.24 1.92C15.7569 1.92 8.88 8.79691 8.88 17.28V22.0781C18.6653 22.9884 24.8729 19.0492 27.7638 10.1386C28.0545 9.24264 29.3272 9.25758 29.5968 10.1601C31.3021 15.8697 34.6146 19.4686 39.6 21.0434ZM6.95999 23.8322L6.95987 21.9528C4.94465 22.4626 3.12002 24.4822 3.12002 26.6294C3.12002 28.9515 4.76897 30.8884 6.95979 31.3332L6.95989 29.2665L6.95999 27.1109V23.8322ZM41.5203 31.3332C43.7111 30.8884 45.36 28.9515 45.36 26.6294C45.36 24.4822 43.5354 22.4626 41.5202 21.9528C41.52 24.3413 41.52 26.3246 41.5201 29.2665L41.5203 31.3332ZM19.3432 37.3157C23.094 39.4358 26.5176 39.4358 29.4356 37.248C29.8598 36.93 29.9459 36.3283 29.6278 35.9041C29.3098 35.4799 28.708 35.3938 28.2838 35.7118C26.0184 37.4104 23.4126 37.4104 20.288 35.6442C19.8265 35.3833 19.2408 35.546 18.9799 36.0076C18.719 36.4691 18.8817 37.0548 19.3432 37.3157Z"
    />
  </svg>
)
